<template>
  <div class="certificate-pointer">
    <div
      class="certificate-pointer__icon-wrapper"
      :style="`--learning-area-color: ${color}`"
      v-tooltip="{
        content: `${certificate.name}`,
        placement: 'top-center',
      }"
    >
      <CertificateIcon />
    </div>
    <span>{{ certificate.short_name }}</span>
  </div>
</template>

<script>
import CertificateIcon from '@/assets/icons/search/certificate.svg'

export default {
  name: 'CertificatePointer',
  components: {
    CertificateIcon,
  },
  props: {
    certificate: {
      type: Object,
      required: true,
    },
    color: {
      type: String,
      required: true,
    },
  },
}
</script>

<style scoped lang="scss">
.certificate-pointer {
  display: flex;
  align-items: center;
  gap: 5px;
  &__icon-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 20px;
    height: 20px;
    border-radius: 50%;
    background-color: var(--learning-area-color);
  }
}
</style>
